<template>
    <div>
        <div v-for="(filterCategory, categoryIndex) in productCategoriesData.filter_categories"  class="filter__section">
            <h5>{{ filterCategory.title }}</h5>

            <label>
                <input class="first-radio" type="radio" :value="0"  v-model="filtered[categoryIndex]"><span class="filter__section-checkbox"></span>{{noPreference}}
            </label>
            <label v-bind:class="{'bordered-bottom': filterOption.icon !== null, 'bordered-top': (filterOption.icon !== null && index === 0)}" v-for="(filterOption, index) in getFilterOptions(filterCategory)">
                <input type="radio" :value="filterOption.id" v-model="filtered[categoryIndex]"><span class="filter__section-checkbox"></span>
                <span class="svg" v-show="filterOption.icon !== null" v-html="filterOption.icon"></span>{{ filterOption.title }}
            </label>
        </div><!-- /.filter-section -->
    </div>
</template>
<script>
    import helpers from '../../helpers';
    export default{
        props: {
            productCategoriesData: {required: true},
        },
        data: function(){
            return {
                helpers: helpers,
                productCategories: [],
                filtered: [0,0,0]
            }
        },
        mounted: function(){
            this.productCategories = this.productCategoriesData;
        },
        methods: {
            resetFilter: function() {
                this.filtered = [0,0,0];
            },
            getFilterOptions: function(filterCategory){
                if(filterCategory.filter_options[0].filter_category_id == 1){
                    let filteredOptions = []
                    Object.keys(filterCategory.filter_options)
                        .sort()
                        .reverse()
                        .forEach(key => {
                            filteredOptions.push(
                                filterCategory.filter_options[key]
                            )
                        })

                    return filteredOptions
                }
                return filterCategory.filter_options
            }
        },
        computed: {
            noPreference: function(){
                if(helpers.getLocale() === 'nl') {
                    return 'Geen voorkeur';
                }
                return 'No preference';
            },
        }
    }
</script>
<style>

    .filter__section label span svg{
        width: 60px;
        margin-right: 13px;
        position: relative;
        top: -0.18em;
        height: auto;
    }

    .bordered-bottom {
        border-bottom: 1px solid #000;
        padding-bottom: 7px;
        padding-top: 13px;
    }

    .bordered-bottom .filter__section-checkbox{
        top: 22px;
    }

    .bordered-top{
        margin-top: 8px;
        border-top: 1px solid #000;
    }

    .filters ul li a{
        padding: 0 5px;
    }




</style>



// WEBPACK FOOTER //
// resources/assets/js/site/components/temporary-bhf-filter/bhf-filter-select.vue